import parse from "html-react-parser";
import { getIconSvgString } from "./icons";
const Icon = (props) => parse(getIconSvgString(props));
export default Icon;
